// Notifications discrètes, avec « Annuler » quand l’action est réversible.
import type { Notice } from '../data/store';
import { esc } from './dom';

let host: HTMLElement | null = null;

function ensureHost(): HTMLElement {
  if (!host || !document.body.contains(host)) {
    host = document.createElement('div');
    host.className = 'toasts';
    host.setAttribute('role', 'status');
    host.setAttribute('aria-live', 'polite');
    document.body.append(host);
  }
  return host;
}

export function showToast(n: Notice): void {
  const h = ensureHost();
  const t = document.createElement('div');
  t.className = 'toast' + (n.kind === 'error' ? ' error' : '');
  t.innerHTML = `<span>${esc(n.text)}</span>${n.undo ? '<button type="button" data-undo>Annuler</button>' : ''}`;
  const remove = () => { t.remove(); };
  const timer = setTimeout(remove, n.undo ? 20000 : n.kind === 'error' ? 9000 : 5000);
  t.querySelector('[data-undo]')?.addEventListener('click', async () => {
    clearTimeout(timer);
    remove();
    try { await n.undo?.(); showToast({ id: -1, text: 'Action annulée.', kind: 'info' }); }
    catch (e) { showToast({ id: -2, text: e instanceof Error ? e.message : 'Annulation impossible.', kind: 'error' }); }
  });
  while (h.children.length >= 3) h.firstElementChild?.remove();
  h.append(t);
}
